import Vue from 'vue'
import ApiBase from '@/api/apiBase'


class ApiIframe {
  static loadTournamentInfo(tournamentId,callBack, errorCallBack){
    ApiBase.get(`tournaments/${tournamentId}/iframe_info`, callBack, ApiBase.noParse, errorCallBack)
  }
}

export default ApiIframe



// WEBPACK FOOTER //
// ./src/api/apiIframe.js